import { Component, Input, OnInit } from '@angular/core';
import { Constant } from '../../../constants/constant';
import { GeneralComponent } from '../general/general.component';

@Component({
  selector: 'calsoft-dynamic-footer',
  imports: [GeneralComponent],
  templateUrl: './dynamic-footer.component.html',
  styleUrl: './dynamic-footer.component.scss'
})
export class DynamicFooterComponent implements OnInit {

  @Input() data: any;

  public PageTitle = Constant.footer

  constructor() { }

  ngOnInit() {
  }
  
}
